var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCiInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8.70833V12.6667M9.5 16.625C8.56433 16.625 7.63783 16.4407 6.77338 16.0826C5.90894 15.7246 5.12348 15.1998 4.46186 14.5381C3.80025 13.8765 3.27542 13.0911 2.91736 12.2266C2.55929 11.3622 2.375 10.4357 2.375 9.5C2.375 8.56433 2.55929 7.63783 2.91736 6.77338C3.27542 5.90894 3.80025 5.12348 4.46186 4.46186C5.12348 3.80025 5.90894 3.27542 6.77338 2.91736C7.63783 2.55929 8.56433 2.375 9.5 2.375C11.3897 2.375 13.2019 3.12567 14.5381 4.46186C15.8743 5.79806 16.625 7.61033 16.625 9.5C16.625 11.3897 15.8743 13.2019 14.5381 14.5381C13.2019 15.8743 11.3897 16.625 9.5 16.625ZM9.53958 6.33333V6.4125H9.46042V6.33333H9.53958Z",
    stroke: "#C8CCD8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiInfo);
export default __webpack_public_path__ + "static/media/ci_info.6339f2436a7b8da20a2a513293133295.svg";
export { ForwardRef as ReactComponent };